import { defineRecipe } from '@chakra-ui/react'

export const buttonRecipe = defineRecipe({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'medium',
    borderRadius: 'base',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    gap: 2,
    _focusVisible: {
      boxShadow: '0 0 0 3px var(--chakra-colors-brand-200)'
    },
  },
  variants: {
    variant: {
      solid: {
        bg: 'brand.500',
        color: 'white',
        _hover: { bg: 'brand.600' },
        _active: { bg: 'brand.700' },
      },
      cta: {
        backgroundImage: 'linear-gradient(135deg, var(--chakra-colors-brand-500), var(--chakra-colors-accent-400))',
        color: 'white',
        shadow: 'md',
        borderRadius: 'full',
        _hover: {
          filter: 'brightness(1.05)',
          transform: 'translateY(-1px)'
        },
        _active: {
          filter: 'brightness(0.98)',
          transform: 'translateY(0)'
        }
      },
      outline: {
        border: '1px solid',
        borderColor: 'brand.500',
        color: 'brand.600',
        _hover: { bg: 'brand.50' },
      },
      ghost: {
        color: 'brand.600',
        _hover: { bg: 'brand.50' },
      },
      soft: {
        bg: 'brand.50',
        color: 'brand.700',
        _hover: { bg: 'brand.100' },
      },
    },
    size: {
      sm: { px: 4, py: 2, h: 8, fontSize: 'sm' },
      md: { px: 6, py: 2.5, h: 10, fontSize: 'md' },
      lg: { px: 8, py: 3, h: 12, fontSize: 'lg' },
    },
  },
  defaultVariants: { variant: 'solid', size: 'md' },
})
